module.exports = __webpack_public_path__ + "img/2.3576e270.jpg";